// extracted by mini-css-extract-plugin
module.exports = {"text":"text___1TF1_"};